import { graphql } from 'gatsby';
import { StyledTitle, StyledList, StyledListItem } from './FooterLinksGroup.styles';
import { StyledLink } from '../../Footer.styles';

const FooterLinksGroup = ({
  footerLinksGroupElements: elements,
}: Queries.FOOTER_LINKS_GROUPFragment) => {
  return (
    <div>
      <StyledTitle>{elements.title.value}</StyledTitle>
      <StyledList>
        {elements.links.value.map((link) => (
          <StyledListItem key={link.system.id}>
            <StyledLink {...link} />
          </StyledListItem>
        ))}
      </StyledList>
    </div>
  );
};

export default FooterLinksGroup;

export const fragment = graphql`
  fragment FOOTER_LINKS_GROUP on kontent_item_footer_links_group {
    id
    footerLinksGroupElements: elements {
      title {
        value
      }
      links {
        value {
          system {
            id
          }
          ...LINK
        }
      }
    }
  }
`;
